import { ChevronLeftIcon } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContainerCard } from "../../components/ui/cards";
import EmployeeAllowanceContent from "./helpers/EmployeeAllowanceContent";

const EmployeeAllowanceManage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { employeeID, employeeName } = location.state || {};

    return (
        <ContainerCard>
            <div className="flex items-center gap-2 mb-4">
                <ChevronLeftIcon onClick={() => navigate(-1)} className="cursor-pointer" />
                <div>
                    <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                        Manage Allowances
                    </h1>
                    {employeeName && (
                        <p className="text-sm text-muted-foreground">{employeeName}</p>
                    )}
                </div>
            </div>
            {employeeID ? (
                <EmployeeAllowanceContent employeeID={employeeID} />
            ) : (
                <p className="text-sm text-muted-foreground">Select an employee from the allowances list.</p>
            )}
        </ContainerCard>
    );
};

export default EmployeeAllowanceManage;
